export const SET_MEDICAL_HISTORY_INITIAL = 'SET_MEDICAL_HISTORY_INITIAL';
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO';
export const UPDATE_NEXT_VERIFY_COUNTDOWN = 'UPDATE_NEXT_VERIFY_COUNTDOWN';
export const SET_REGISTER_SUCCESS_MODAL_OPEN = 'SET_REGISTER_SUCCESS_MODAL_OPEN';

export const SEND_VERIFICATION_CODE_SAGA = 'SEND_VERIFICATION_CODE_SAGA';
export const USER_REGISTER_SAGA = 'USER_REGISTER_SAGA';
export const USER_LOGIN_SAGA = 'USER_LOGIN_SAGA';
export const UPDATE_USER_INFO_SAGA = 'UPDATE_USER_INFO_SAGA';
export const SYNC_AVATAR_SAGA = 'SYNC_AVATAR_SAGA';
export const RESET_USER_PASSWORD_SAGA = 'RESET_USER_PASSWORD_SAGA';
export const CHANGE_USER_PASSWORD_SAGA = 'CHANGE_USER_PASSWORD_SAGA';
export const REFRESH_USER_INFO_SAGA = 'REFRESH_USER_INFO_SAGA';
export const LOGOUT_USER_SAGA = 'LOGOUT_USER_SAGA';

export const setMedicalHistoryInitial = selected => ({
  type: SET_MEDICAL_HISTORY_INITIAL,
  selected
});

export const updateUserInfo = payload => ({
  type: UPDATE_USER_INFO,
  payload,
});

export const deleteUserInfo = () => ({
  type: UPDATE_USER_INFO,
  payload: null,
});

export const userRegister = payload => ({
  type: USER_REGISTER_SAGA,
  payload,
});

export const sendVerificationCode = (cellphone, scope) => ({
  type: SEND_VERIFICATION_CODE_SAGA,
  cellphone, scope,
});

export const updateNextVerifyCountdown = value => ({
  type: UPDATE_NEXT_VERIFY_COUNTDOWN,
  value,
});

export const setRegisterSuccessModal = open => ({
  type: SET_REGISTER_SUCCESS_MODAL_OPEN,
  open,
});

export const login = (cellphone, password) => ({
  type: USER_LOGIN_SAGA,
  cellphone,
  password,
});

export const requestUpdateUserInfo = payload => ({
  type: UPDATE_USER_INFO_SAGA,
  payload,
});

export const syncAvatar = () => ({
  type: SYNC_AVATAR_SAGA,
});

export const resetPassword = (cellphone, code, newPassword) => ({
  type: RESET_USER_PASSWORD_SAGA,
  cellphone,
  code,
  new_password: newPassword,
});

export const changePassword = (oldPassword, newPassword) => ({
  type: CHANGE_USER_PASSWORD_SAGA,
  old_password: oldPassword,
  new_password: newPassword,
});

export const refreshUserInfo = () => ({
  type: REFRESH_USER_INFO_SAGA,
});

export const logout = () => ({
  type: LOGOUT_USER_SAGA,
});



// WEBPACK FOOTER //
// ./src/actions/user.js